import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { RouterModule } from '@angular/router';
import { NamedRouterOutletModule } from './named-router-outlet';
import { WebComponentBridgeComponent } from './web-component-bridge.component';
import { WebComponentBridgeService } from './web-component-bridge.service';

@NgModule({
  declarations: [WebComponentBridgeComponent],
  imports: [CommonModule, RouterModule, NamedRouterOutletModule],
  exports: [WebComponentBridgeComponent],
  providers: [WebComponentBridgeService],
})
export class WebComponentBridgeModule {
  constructor(private injector: Injector) {
    const customElement = createCustomElement(WebComponentBridgeComponent, { injector: this.injector });
    customElements.define('cf-wc-bridge', customElement);
  }
}
